import api from "../../utilidades/interceptor";
import {encriptar} from "../../utilidades/encriptacion";
const urlApi = process.env.REACT_APP_API_KEY
const key = process.env.REACT_APP_CLAVE_INCRIPTACION
export const addHealthTracker = async (data) => {
    try {
       const result = await api.post(`${urlApi}/healthTracker/addHealthTracker`, data);
        const auth = encriptar("true", key);
        sessionStorage.setItem("auth", auth);
        window.location.href = '/administracion';
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}
